<template>
    <div>    
        <v-card color="transparent"  flat tile>
            <v-card class="mb-5" v-if="QUESTION_TIMELINE">
                <mbs-page-tab
                    :items="QUESTION_TIMELINE" /> 
            </v-card>
            <span v-for="(category,index) in QUESTION_CATEGORIES" :key="index" class="px-2">
                <span class="font-weight-bold">{{category.name}}</span>
                <span v-for="(question, index) in QUESTION_CATEGORIES_ITEMS(category.code)"   :key="index" >
                    <div class="pa-4"> 
                        <v-layout row wrap class="ma-0">
                            <span class="pr-2">{{question.question_number}}</span>
                            <span>{{question.question_body}}</span>
                        </v-layout>
                        <span v-if="QUESTION_FIELDS(question)">  
                            <span v-if="PAGE_LOAD">
                                <mbs-input-fields
                                    v-model="input"
                                    :field_items="[...QUESTION_FIELDS(question)]"
                                    :select_items="null"
                                    :disabled_fields="null"
                                    />   
                            </span>
                        </span>
                        <!-- {{question}} -->
                        
                    </div>
                </span>  
            </span>
        </v-card>
        <!-- //DIALOGS -->
        <div>   
        </div>
    </div> 
</template>

<script>
    import DATA from '../../plugins/DATA';
    import {mapState} from "vuex"
    let PAGE_NAME  = "QUESTIONNAIRE" 
    
    export default {
        name:PAGE_NAME,
        props:[
            'show','value', 
            'question_items',  
            'report','value',  
        ],
        data() {
            return { 
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,
  
                excelSelecter:false,
                EXCEL_DATA_ITEMS:[],
                generatedCode:null, 
                inputCode:null, 
                inputCodeLoading:false, 
                menu_date_picker:{},
                menu_time_picker:{},
                dialog_time_picker:{},
                dialogInput:{},
                search:'',  
                search_input:null,   
                input:{},
                input_load:true,
                input_report:this.value,
                selected_field_action:null, 
                DATA:DATA, 
            }
        },
        created() {
            try {
                // this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);   
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try {   
                if (this.report) {
                    this.PAGE_LOAD = false
                    setTimeout(() => {
                        let report_answer = this.report.report_answer
                        let input = {}
                        if (report_answer) {
                            report_answer.forEach(element => {
                                if (element.answer) {
                                    input[element.question_code+"__"+element.question_number]=element.answer  
                                }
                                
                                if (element.explanation) {
                                    input[element.question_code+"__"+element.question_number+"__explanation"]=element.explanation  
                                }
                            }); 
                        } 
                        this.input = input
                        this.PAGE_LOAD = true
                    }, 100);
                }
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: {
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            }, 
            accessPage(){
                return this.not.ACCESS_PAGE(this.$route.name)
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                SMSReports: state=> state.items[(DATA.ITEMS.SMS_REPORTS.values).toUpperCase()],
                JoinedSMSReports: state=> state.join[(DATA.ITEMS.SMS_REPORTS.values).toUpperCase()],
                
            }), 
            QUESTION_ITEMS(){
                let questions = this.question_items
                return questions
            },
            QUESTION_TIMELINE(){
                let questions = this.QUESTION_ITEMS
                if(!questions){return null}
                let timeline = []
                questions.forEach(element => {
                    let question_timeline = element.question_timeline
                    let question_timeline_code = element.question_timeline_code
                    if (!question_timeline ||question_timeline_code) {
                        question_timeline = this.$store.getters.getQuestionTimelineByCode(question_timeline_code)
                    }
                    if (question_timeline) {
                        let index = timeline.findIndex(timeline=>timeline.code==question_timeline_code)
                        if (index==-1) {
                            timeline.push(question_timeline) 
                        }
                    }
                });
                return timeline
            },
            QUESTION_CATEGORIES(){
                let questions = this.QUESTION_ITEMS
                if(!questions){return null}
                let categories = []
                questions.forEach(element => {
                    let question_category = element.question_category
                    let question_category_code = element.question_category_code
                    if (!question_category ||question_category_code) {
                        question_category = this.$store.getters.getQuestionCategoryByCode(question_category_code)
                    }
                    if (question_category) {
                        let index = categories.findIndex(category=>category.code==question_category_code)
                        if (index==-1) {
                            categories.push(question_category) 
                        }
                    }
                });
                return categories
            },
            QUESTION_CATEGORIES_ITEMS(){
                let questions = this.QUESTION_ITEMS 
                return question_category_code=>{
                    if(!questions){return null}
                    return questions.filter(question=>question.question_category_code == question_category_code) 
                }
            },
            QUESTION_FIELDS(){
                return question =>{
                    try {  
                        let fields = []

                        if (question.question_type_name == "number") {
                            fields.push({
                                type:"number",value:question.code+'__'+question.question_number,label:"Enter number",
                                label_top:"",required:false,sm:12,md:12
                            }) 
                        }else if (question.question_type_name == "yes/no") {
                            fields.push({
                                type:"yes_or_no",value:question.code+'__'+question.question_number,label:"Enter number",
                                label_top:"",required:false,sm:12,md:12
                            }) 
                        }else if (question.question_type_name == "multiple choice") {
                            fields.push({
                                type:"autocomplete",value:question.code+'__'+question.question_number,label:"Enter number",
                                label_top:"",required:false,sm:12,md:12
                            }) 
                        }else if (question.question_type_name == "gender") {
                            fields.push({
                                type:"select_gender",value:question.code+'__'+question.question_number,label:"Enter number",
                                label_top:"",required:false,sm:12,md:12
                            }) 
                        }else if (question.question_type_name == "time") {
                            fields.push({
                                type:"time",value:question.code+'__'+question.question_number,label:"Enter number",
                                label_top:"",required:false,sm:12,md:12
                            }) 
                        }else if (question.question_type_name == "date") {
                            fields.push({
                                type:"date",value:question.code+'__'+question.question_number,label:"Enter number",
                                label_top:"",required:false,sm:12,md:12
                            }) 
                        }else{
                            fields.push({
                                type:"text",value:question.code+'__'+question.question_number,label:"",
                                label_top:"",required:false,sm:12,md:12
                            }) 
                        }
                         

                        if (question.question_has_explanation) {
                            fields.push({
                                type:"textarea",value:question.code+'__'+question.question_number+"__explanation",label:"Explain",
                                label_top:"",required:false,sm:12,md:12
                            }) 
                        }
                        return fields
                    } catch (error) {
                        this.MBS.actions.error({
                            error:error,
                            from:'FIELD_APPEND_ACTIONS',
                            page:PAGE_NAME, 
                        }) 
                    }  
                }
            }, 
              
        },
        methods: {   
            FIELDS_ACTION(action){
                try {   
                    this.selected_field_action = action
                    // if (action.action=="add_item") {
                        setTimeout(() => { 
                            this.MBS.events.$emit("ITEM_ACTION",action.action,action)
                        }, 0);
                    // }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FIELD_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            AT_SEARCH_INPUT(input){
                try {  
                    this.search_input = input
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'AT_SEARCH_INPUT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            CREATE_FIELDS_ARRAY_DATA(child,input,notify){
                try { 
                    let code = this.inputCode
                    //CREATE ITEM ARRAY
                    let fields_array_data = {}
                    let required = false
                    let field_items = child?this.FIELD_CHILD_ITEMS:this.FIELD_ITEMS
                    if (input.key) {
                        fields_array_data["key"]=input.key
                    }
                    field_items.forEach(field => {
                        if (field.value==='code') {
                            fields_array_data.code = code 
                        } else {
                            let value = input[field.value]?input[field.value]:null
                            if (!value) {
                                if (field.required) {
                                    if (notify) {
                                        this.MBS.actions.dialog({
                                            show:true,
                                            fixed:false,
                                            title:this.MBS.text.field_required(field.label).title,
                                            text:this.MBS.text.field_required(field.label).text,
                                            btnYes:this.MBS.text.field_required(field.label).btnYes
                                        }) 
                                    }
                                    required = true
                                }
                            }else{
                                fields_array_data[field.value] = value 
                            }
                        } 
                    }); 
                    return {
                        fields_array_data:fields_array_data,
                        required:required
                    }
                         
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CREATE_FIELDS_ARRAY_DATA',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
            INPUT_WAITING(){
                if (!this.input_waiting) {
                    this.input_waiting = true
                    setTimeout(() => {
                        this.input_waiting = false
                        this.CREATE_ANSWER(this.input,this.report)
                    }, 1000); 
                }
            },
            CREATE_ANSWER(input,report){
                try { 
                    let report_info ={
                        region_code:report.region_code,
                        district_code:report.district_code,
                        constituency_code:report.constituency_code,
                        ward_code:report.ward_code,
                        centre_code:report.centre_code,
                        occurrence_code:report.occurrence_code,
                        user_type:'user',
                    }
                    let answer_report = []
                    for (const key in input) {
                        let question_code = key.split("__")[0]
                        let question_number = key.split("__")[1]
                        let explanation = key?key.includes('explanation'):false
                        let index = answer_report.findIndex(rep=>rep.question_code == question_code)
                        let report_details = {
                            ...report_info,
                            code:key,
                            key:report.key+"__"+question_code,
                            question_code:question_code, 
                            question_number:question_number, 
                            question_has_explanation:explanation, 
                            question_answer:question_number+input[key], 
                            answer:input[key], 
                        }
                        let report_explanation = {
                            ...report_info,
                            code:key,
                            key:report.key+"__"+question_code,
                            question_code:question_code, 
                            question_number:question_number, 
                            question_has_explanation:explanation,  
                            explanation:input[key], 
                        }
                        if (index==-1) {
                            answer_report.push(explanation?report_explanation:report_details) 
                        }else{
                            if (explanation) {
                                answer_report[index]= {...answer_report[index],...report_explanation}
                            }else{
                                answer_report[index]= {...answer_report[index],...report_details}  
                            }
                        }
                    } 
                    this.$emit('input', answer_report) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CREATE_ANSWER',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
            async setAutoCode(values,notify=true){ 
                this.inputCodeLoading = true
                try {
                    if (this.generatedCode) {
                        this.inputCode = this.generatedCode
                        this.inputCodeLoading = false 
                    }else{
                        let res = await this.MBS.actions.CODE_GENERATE(
                            this.MBS.actions.TEXT_UP(values)) 
                        this.inputCode= res.code 
                        this.generatedCode= res.code 
                        this.input.generatedCode= res.code 
                        this.inputCodeLoading = false 
                    }
                    if (notify) {
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:this.MBS.text.generate_code_successful.title,
                            text:this.MBS.text.generate_code_successful.text,
                            btnYes:this.MBS.text.generate_code_successful.btnYes,
                        })   
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'setAutoCode',
                        page:PAGE_NAME, 
                    }) 
                    this.inputCodeLoading = false
                }
            },
            isAutoCode(code){ 
                try {
                    if(!this.generatedCode){return false}
                    if(!code){return false}
                    if (this.generatedCode === code) {
                        return true
                    } 
                } catch (error) {
                   this.MBS.actions.error({
                        error:error,
                        from:'isAutoCode',
                        page:PAGE_NAME, 
                    })  
                }
                return false
            }, 
            
            //---------------[MAIN FUNCTIONS]------------
            SAVE_DIALOG_TIME_PICKER(value){
                try {
                   this.input[value] = this.dialogInput[value] 
                   this.dialog_time_picker[value]= false
                   this.UPDATE_MODEL()
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_MODEL',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            UPDATE_MODEL(){
                try { 
                    this.search_input=null
                    this.$emit('input', {...this.input})
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_MODEL',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {  
                        if (action.code ===PAGE_NAME+'=AUTO-GENERATE-CODE') { 
                            if (action.YES) {
                                this.EXCEL_DATA_ITEMS= this.MBS.actions.CODE_AUTO_GENERATE(this.EXCEL_DATA_ITEMS) 
                                setTimeout(() => { 
                                    this.MBS.actions.dialog({
                                        show:true,
                                        fixed:true,
                                        title:'GENERATED',
                                        text:"Code, successfully generated.",
                                        btnYes:"OK"
                                    }) 
                                }, this.MBS.data.ACTION_REFRESH_TIME); 
                            } else { 
                            }
                        } 
                        if (action.code ===PAGE_NAME+'=AUTO-SET-CODE') { 
                            if (action.YES) {
                                this.inputCodeLoading = true
                                setTimeout(() => { 
                                    this.setAutoCode()
                                }, this.MBS.data.ACTION_REFRESH_TIME); 
                            } else {
                                
                            }
                        } 
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },
              
        },
        beforeDestroy(){
            this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);    
        },
        watch: { 
            us(v){ 
            },  
            input(currentValue) {   
                this.INPUT_WAITING()   
            }, 
            input_report(currentValue) {  
                console.log(currentValue,'in....'); 
            }, 
            inputCode(currentValue) { 
                this.input.code=currentValue
            },    
        },
  }
</script>